export default __webpack_public_path__ + "static/media/S.72d9ae27.svg";